export enum PeriodLabelText {
    Current = 'Current',
    OneYearAgo = '1 Year Ago',
    TwoYearsAgo = '2 Years Ago',
}

export interface PeriodLabel {
    label: PeriodLabelText;
    range: string;  // e.g. "2024" for calendar year, or "7/1/2024 – 6/30/2025" for fiscal
}

export interface PeriodLabels {
    current: PeriodLabel;
    one_year_ago: PeriodLabel;
    two_years_ago: PeriodLabel;
}
